interface IRoleGroupSummary {
  id: string;
  groupName: string;
}

interface IRoleUserSummary {
  id: string;
  displayName: string;
}

interface IRole {
  id: string;
  roleName: string;
  description: string;
  systemKey: string;
  isSystemDefined: boolean;
  isActive: boolean;
  isArchived: boolean;
  organizationId: string;
  // Optional on the wire: legacy/pre-ZOO-9515 API responses may not send scope at all, in which
  // case it's treated as Org-eligible (see role-detail.component.ts / group-detail.component.ts).
  // RoleModel itself always defaults it below, so code working with a constructed RoleModel can
  // still rely on the field being present.
  scope?: string;
  permissions: string[];
  assignedGroups: IRoleGroupSummary[];
  assignedUsers: IRoleUserSummary[];
}

export interface RoleSavePayload {
  roleName: string;
  description?: string;
  isActive?: boolean;
  scope?: string;
  permissionIds: string[];
  groupIds: string[];
  organizationId?: string;
}

export class RoleModel implements IRole {
  id: string = '';
  roleName: string = '';
  description: string = '';
  systemKey: string = '';
  isSystemDefined: boolean = false;
  isActive: boolean = true;
  isArchived: boolean = false;
  organizationId: string = '';
  scope: string = 'Org';
  permissions: string[] = [];
  assignedGroups: IRoleGroupSummary[] = [];
  assignedUsers: IRoleUserSummary[] = [];

  constructor(props: Partial<IRole> = {}) {
    Object.assign(this, props);
    this.permissions = this.permissions ?? [];
    this.assignedGroups = this.assignedGroups ?? [];
    this.assignedUsers = this.assignedUsers ?? [];
  }
}
